import React from 'react';
import { AppRouter } from './router/index';
import { AuthProvider } from './providers/AuthProvider';
import { I18nProvider } from './providers/I18nProvider';
import { CompanyProvider } from './providers/CompanyProvider';
export function App() {
  return <AuthProvider data-id="element-0">
      <I18nProvider data-id="element-1">
        <CompanyProvider data-id="element-2">
          <AppRouter data-id="element-3" />
        </CompanyProvider>
      </I18nProvider>
    </AuthProvider>;
}